/**
 * External dependencies
 */
import { ContainerIcon } from '~cartzillagb/icons'
import { disabledBlocks, i18n } from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'

export const schema = {
	className : {
		type: 'string',
	},
	enableContainer: {
		type: 'boolean',
		default: true,
	},
	enablemaxwidth: {
		type: 'boolean',
		default: false,
	},
	width : {
		type: 'number',
		default: 35,
	},
}

export const name = 'czgb/container'

export const settings = {
	title: __( 'Container', i18n ),
	icon: ContainerIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'container', i18n ),
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	description: __( 'A styled container that you can add other blocks inside. Use this to create unique layouts.', i18n ),
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}